<!-- GlobalLoginModal.vue -->
<template>
	<div>
		<el-dialog :visible.sync="visible" append-to-body width="760px" :close-on-click-modal="false" @close="handleClose">
			<div class="flex-betweenCenter">
				<div class="login-img position-relative" @click="getVerifyCode(1)">
					<div class="position-absolute width50 height100" style="top:0 left: 0;opacity: 0;">按钮</div>
					<img src="@/assets/images/login.png" alt="">
				</div>
				<div class="login-right">
					<div class="font20 flex-betweenCenter margin-bottom20 cursor-active">
						<div class="width50p flex-center height40" :class="activeName==1?'tabActive':''" @click="handleClick(1)">
							手机登录
						</div>
						<div class="width50p flex-center height40" :class="activeName==2?'tabActive':''" @click="handleClick(2)">
							二维码登录
						</div>
					</div>
					<!-- 手机登录 -->
					<div class="right-height" v-if="activeName==1">
						<el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0">
							<!-- 手机号输入框 -->
							<el-form-item prop="phone">
								<el-input v-model="loginForm.phone" placeholder="请输入手机号" maxlength="11" @input="formatPhone">
									<img slot="prefix" class="width15 height15 margin-left5 margin-top12"
										src="@/assets/images/icon-phone.png" alt="" />
								</el-input>
							</el-form-item>

							<!-- 验证码输入框 -->
							<el-form-item prop="code">
								<el-row :gutter="10">
									<el-col :span="15">
										<el-input v-model="loginForm.code" placeholder="请输入验证码" maxlength="6"
											prefix-icon="el-icon-lock"></el-input>
									</el-col>
									<el-col :span="9">
										<el-button :disabled="codeDisabled" @click="getVerifyCode()" style="width: 100%;">
											{{ codeText }}
										</el-button>
									</el-col>
								</el-row>
							</el-form-item>
						</el-form>

						<div slot="footer" class="dialog-footer">
							<el-button type="primary" class="width100p border-radius6 bg-blue border-blue" @click="handleLogin"
								:loading="loginLoading">注册/登录</el-button>
							<div class="flex-startCenter margin-top15 readAll" @click="readAll">
								<img class="width18 height18 margin-right5" v-if="readed1 && readed2" src="@/assets/images/checked.png"
									alt="">
								<img class="width18 height18 margin-right5" v-if="!readed1 || !readed2" src="@/assets/images/check.png"
									alt="">
								<div class="flex-startCenter margin-left5">
									我已阅读并同意
									<div class="color-blue weight550" @click.stop="agreeShow2=true">《用户协议》</div>
									和
									<div class="color-blue weight550" @click.stop="agreeShow1=true">《隐私协议》</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 二维码登录 -->
					<div v-else class="flex-columnCenter right-height">
						<!-- 二维码容器 -->
						<div id="login_container" class="qr-container"></div>
						<!--  @click="wxFun" -->
						<!-- <div class="flex-center font20 margin-top20 margin-bottom10">
							打开 <span class="color-blue font24">微信扫一扫</span>
						</div> -->
						<!-- <div class="font14 color-grey9">使用微信扫码快速登录/注册</div> -->

						<!-- <div class="flex-center margin-top20">
							<el-button type="text" @click="refreshQrCode">
								<i class="el-icon-refresh-right"></i> 刷新二维码
							</el-button>
						</div> -->
					</div>
				</div>
			</div>

			<!-- 协议弹窗 -->
			<el-dialog :visible="agreeShow1" width="1000px" append-to-body @close="agreeShow1=false">
				<div class="padding20 flex-columnCenter">
					<div class="font20">隐私协议</div>
					<div class="agree-wrap" v-html="agreement1"></div>
					<el-button type="primary" class="width300 border-radius6 bg-blue border-blue" @click="know(1)">知道了</el-button>
				</div>
			</el-dialog>

			<el-dialog :visible="agreeShow2" width="1000px" append-to-body @close="agreeShow2=false">
				<div class="padding20 flex-columnCenter">
					<div class="font20">用户协议</div>
					<div class="padding20 flex-columnCenter">
						<div class="agree-wrap" v-html="agreement2"></div>
						<el-button type="primary" class="width300 border-radius6 bg-blue border-blue"
							@click="know()">知道了</el-button>
					</div>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import bus from '@/utils/bus'
	import {
		sendCode,
		phoneLogin,
		agreement,
		privacy,
		getCode
	} from '@/api/user'

	// 声明全局 WxLogin 类型，避免 ESLint 报错
	/* global WxLogin */

	export default {
		name: 'GlobalLoginModal',
		data() {
			return {
				activeName: 1,
				visible: false,
				loginLoading: false,
				codeDisabled: false,
				codeText: '获取验证码',
				countdown: 60,
				loginForm: {
					phone: '',
					code: ''
				},
				loginRules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							pattern: /^1[3-9]\d{9}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},
				readed1: false,
				readed2: false,
				agreement1: '',
				agreement2: '',
				agreeShow1: false,
				agreeShow2: false,
				wechatWindow: null, // 微信登录弹窗引用
				messageListener: null, // 消息监听器
				timer: null, // 倒计时定时器
				qrCreateTime: null // 二维码创建时间
			}
		},
		created() {
			// 监听显示登录弹窗的全局事件
			bus.$on('showLoginModal', () => {
				this.visible = true
				this.activeName = 1
				this.getInfo()
				this.$refs.loginForm?.resetFields()
				// 重置微信扫码
				this.resetWechatQr()
			})

			// 监听跨窗口消息
			this.messageListener = this.handleWindowMessage.bind(this)
			window.addEventListener('message', this.messageListener)

			// 监听页面可见性变化，用于处理 localStorage 变化
			document.addEventListener('visibilitychange', this.handleVisibilityChange)
		},
		mounted() {
			// 检查是否有未完成的微信登录
			this.checkWechatLoginStatus()
		},
		beforeDestroy() {
			bus.$off('showLoginModal')
			if (this.timer) {
				clearInterval(this.timer)
			}
			window.removeEventListener('message', this.messageListener)
			document.removeEventListener('visibilitychange', this.handleVisibilityChange)
			if (this.wechatWindow && !this.wechatWindow.closed) {
				this.wechatWindow.close()
			}
		},
		methods: {
			handleClick(val) {
				this.activeName = val
				if (val === 2) {
					// 延迟初始化，确保 DOM 已渲染
					this.$nextTick(() => {
						this.initWechatQr()
					})
				} else if (val === 1) {
					// 切换到手机登录时，清空二维码容器
					this.resetWechatQr()
				}
			},
			wxFun() {
				// this.$nextTick(() => {
				this.initWechatQr()
				// })
			},

			// 初始化微信二维码
			initWechatQr() {
				// 确保容器存在且为空
				const container = document.getElementById('login_container')
				if (!container) return

				// 清空容器内容，避免重复渲染
				container.innerHTML = ''

				// 检查 WxLogin 是否已加载
				if (typeof WxLogin === 'undefined') {
					console.error('WxLogin is not loaded. Please check the script import.')
					this.$message.error('微信登录组件加载失败，请刷新页面重试')
					return
				}
				// --- 根据环境动态获取配置 ---
				const isDev = process.env.NODE_ENV === 'development'

				// 根据环境动态设置 CSS 文件路径
				const getCssUrl = () => {
					// 开发环境：使用本地开发服务器地址
					// if (process.env.NODE_ENV === 'development') {
					if (isDev) {
						return 'http://localhost:8080/login.css' // 注意端口号要与您的开发服务器一致
					} else {
						// 生产环境：使用线上地址
						return 'https://edu.kaoyaai.com/login.css'
					}
				}
				// // 根据环境动态设置回调地址
				// const getRedirectUri = () => {
				// 	if (isDev) {
				// 		// 本地开发环境：使用 localhost + 端口号
				// 		// 注意：需要在微信开放平台配置 localhost 为授权回调域
				// 		return 'http://localhost:8080/#/wechatcall'
				// 	} else {
				// 		// 生产环境：使用线上地址
				// 		return 'https://edu.kaoyaai.com/#/wechatcall'
				// 	}
				// }
				// const redirectUri = encodeURIComponent(getRedirectUri());
				// 编码回调地址
				const redirectUri = encodeURIComponent('https://edu.kaoyaai.com/wechat.html');

				// 使用 WxLogin，赋值给变量避免 no-new 警告
				const wxLoginInstance = new WxLogin({
					id: 'login_container',
					self_redirect: false,
					appid: 'wxefa46f0fcbc53ab2',
					scope: 'snsapi_login',
					redirect_uri: redirectUri,
					state: Math.random().toString(36).substring(2, 15), // 随机 state 防止 CSRF
					style: 'black',
					// href: '' // 可选：自定义样式链接 不需要设置了，因为已经在 index.html 中全局引入
					href: getCssUrl() // 关键：设置 href 参数为 CSS 文件的完整 URL
				})

				// 存储实例供后续使用（如果需要）
				this.wxLoginInstance = wxLoginInstance

				// 保存二维码出现的时间，用于判断是否超时
				this.qrCreateTime = Date.now()
			},

			// 刷新二维码
			refreshQrCode() {
				this.initWechatQr()
			},

			// 重置微信扫码
			resetWechatQr() {
				const container = document.getElementById('login_container')
				if (container) {
					container.innerHTML = ''
				}
				this.wxLoginInstance = null
				this.qrCreateTime = null
			},

			// 处理跨窗口消息
			handleWindowMessage(event) {
				// 可以添加来源验证
				if (event.data && event.data.type === 'WECHAT_LOGIN_SUCCESS') {
					this.checkWechatLoginStatus()
				}
			},

			// 检查微信登录状态
			checkWechatLoginStatus() {
				const loginSuccess = localStorage.getItem('wechatLoginSuccess')
				const loginTime = localStorage.getItem('wechatLoginTime')

				if (loginSuccess === 'true' && loginTime) {
					// 检查是否是最近5秒内的登录
					const timeDiff = Date.now() - parseInt(loginTime)
					if (timeDiff < 10000) {
						// 清除标识
						localStorage.removeItem('wechatLoginSuccess')
						localStorage.removeItem('wechatLoginTime')

						// 获取用户信息
						const token = localStorage.getItem('token')
						const userInfo = localStorage.getItem('userInfo')

						if (token && userInfo) {
							this.$message.success('微信登录成功')
							this.visible = false
							bus.$emit('loginSuccess', JSON.parse(userInfo))
							this.resetWechatQr()
							this.$refs.loginForm?.resetFields()
						}
					}
				}
			},

			// 页面可见性变化处理（用户从微信返回时触发）
			handleVisibilityChange() {
				if (!document.hidden) {
					// 页面重新可见时检查登录状态
					setTimeout(() => {
						this.checkWechatLoginStatus()
					}, 500)
				}
			},

			getInfo() {
				agreement().then(res => {
					this.agreement1 = res.data
				}).catch(err => {
					this.agreement1 = ''
				})
				privacy().then(res => {
					this.agreement2 = res.data
				}).catch(err => {
					this.agreement2 = ''
				})
			},

			formatPhone() {
				this.loginForm.phone = this.loginForm.phone.replace(/\D/g, '')
			},

			handleClose() {
				this.visible = false
				this.$refs.loginForm?.resetFields()
				this.codeDisabled = false
				this.codeText = '获取验证码'
				if (this.timer) {
					clearInterval(this.timer)
					this.timer = null
				}
				this.countdown = 60
				this.resetWechatQr()
			},

			getVerifyCode(type) {
				this.$refs.loginForm.validateField('phone', (err) => {
					if (!err) {
						this.codeDisabled = true
						this.timer = setInterval(() => {
							this.countdown--
							this.codeText = `${this.countdown}s后重新获取`
							if (this.countdown <= 0) {
								clearInterval(this.timer)
								this.timer = null
								this.codeText = '获取验证码'
								this.codeDisabled = false
								this.countdown = 60
							}
						}, 1000)

						sendCode({
							phone: this.loginForm.phone
						}).then(res => {
							this.$message.success('验证码已发送')
							if (type) {
								this.loginForm.code = res.data
							}
						}).catch(err => {
							this.$message.error(err.errmsg)
						})
					} else {
						this.$message.error('请输入正确的手机号')
					}
				})
			},

			handleLogin() {
				this.$refs.loginForm.validate((valid) => {
					if (valid) {
						if (!this.readed1 || !this.readed2) {
							this.$message.warning('请先同意相关协议')
							return
						}
						this.loginForm.province_id = localStorage.getItem('provinceId')
						this.loginLoading = true
						phoneLogin(this.loginForm).then(res => {
							this.visible = false
							this.$refs.loginForm.resetFields()
							this.codeDisabled = false
							this.codeText = '获取验证码'
							if (this.timer) {
								clearInterval(this.timer)
								this.timer = null
							}
							this.countdown = 60
							bus.$emit('loginSuccess', res.data)
						}).catch(err => {
							this.$message.error(err.message || '登录失败')
						}).finally(() => {
							this.loginLoading = false
						})
					}
				})
			},

			readAll() {
				this.readed1 = !this.readed1
				this.readed2 = this.readed1
			},

			know(val) {
				if (val) {
					this.readed1 = true
					this.agreeShow1 = false
				} else {
					this.readed2 = true
					this.agreeShow2 = false
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.login-img {
		width: 307px;
		height: 467px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.readAll {
		cursor: pointer;
	}

	.login-right {
		width: 400px;
		padding: 0 30px;

		.right-height {
			height: 300px;
		}

		.tabActive {
			position: relative;
			color: #28b05e;

			&:before {
				content: '';
				position: absolute;
				width: 35px;
				height: 3px;
				border-radius: 2px;
				background: #28b05e;
				bottom: 0;
				left: 40%;
			}
		}
	}

	.dialog-footer {
		margin-top: 68px;
	}

	::v-deep {
		.el-dialog {
			border-radius: 12px;

			&__header,
			&__body {
				padding: 0;
			}
		}
	}

	.qr-container {
		width: 214px;
		height: 214px;
		margin: 0 auto;

		iframe {
			width: 100% !important;
			height: 100% !important;
			border: none;
		}
	}

	.agree-wrap {
		max-height: 500px;
		overflow-y: auto;
		margin-bottom: 20px;
	}

	.el-input__prefix {
		color: #c0c4cc;
	}
</style>
